module.exports = __webpack_public_path__ + "static/media/B3.78397405.jpg";